import pluralize from 'pluralize';

import { useResponsive } from 'shared/hooks';
import { useGroupMembers } from 'features/groups/hooks';
import { LoadingOverlay } from 'shared/components/ui';
import { GroupInfoFragment } from 'shared/graphql';

import {
  Container,
  Content,
  Description,
  Divided,
  Header,
  Logo,
  MembersCount,
  Title,
} from './ExplorerGroupCard.styles';
import {
  ExplorerGroupCardButtons,
  ExplorerGroupCardButtonOptions,
} from './ExplorerGroupCardButtons';

interface Props extends ExplorerGroupCardButtonOptions {
  data: GroupInfoFragment;

  /** @default "list" */
  variant?: 'list' | 'grid';

  onClick?(): void;
}

export function ExplorerGroupCard(props: Props) {
  const description = props.data.description;
  const variant = props.variant ?? 'list';

  const { isMobile } = useResponsive();
  const { data: members, isLoading } = useGroupMembers(props.data.id);

  const membersCount = members.length;

  const Buttons = (
    <ExplorerGroupCardButtons
      data={props.data}
      withJoin={props.withJoin}
      withMessage={props.withMessage}
      withViewProfile={props.withViewProfile}
    />
  );

  if (variant === 'grid') {
    return (
      <Container borderless={isMobile}>
        <Divided>
          <Logo group={props.data} />

          <Content>
            <Title group={props.data} />

            <LoadingOverlay loading={isLoading}>
              <MembersCount>
                {membersCount} {pluralize('member', membersCount)}
              </MembersCount>
            </LoadingOverlay>

            {Buttons}
          </Content>
        </Divided>

        <Description>{description}</Description>
      </Container>
    );
  }

  return (
    <Container borderless={isMobile}>
      <Divided>
        <Logo group={props.data} />

        <Content>
          <Header>
            <Title group={props.data} />

            {Buttons}
          </Header>

          <LoadingOverlay loading={isLoading}>
            <MembersCount>
              {membersCount} {pluralize('member', membersCount)}
            </MembersCount>
          </LoadingOverlay>

          <Description>{description}</Description>
        </Content>
      </Divided>
    </Container>
  );
}
